import { getResponsiveStyles } from '../../../component-themes';
export const navigationBarActionsSecondary = (tokens) => ({ size }) => getResponsiveStyles(size, (size) => ({
    gap: tokens.styles[`navigation-bar-actions-secondary-base-${size}-gap`],
}));
